import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles({ 
  header: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    paddingLeft: 15,
    paddingTop: 12,
    paddingBottom: 8
  },
  col1: {
    width: '100%', 
    flexDirection: 'column', 
    display: 'flex'
  },  
  alert: {
    height: 25, 
    width: 125, 
    backgroundColor: '#FFF7E1', 
    border: '1px solid #FFB626', 
    borderRadius: 2, 
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  headerOrigem: {
    fontSize: 12, 
    fontWeight: 700, 
    color: 'gray'
  },
  headerEmpresa: {
    fontSize: 13,
    fontWeight: 700, 
    wordBreak: 'break-word'
  },
  switch: {
    "& .Mui-checked": {
      color: '#fff'
    },
    '&  .Mui-checked + .MuiSwitch-track': {
      backgroundColor: '#69ABCF',
      color: '#69ABCF',
      opacity: 1
    },
  }
});